// Buat file baru: src/features/monthly-setup/components/RatePlanSelector.tsx

import React from 'react';
import Select, { StylesConfig, GroupBase } from 'react-select';

// Tipe untuk opsi yang akan kita gunakan
export type RatePlanOption = {
    value: string; // rate plan id
    label: string; // "Room Name - Rate Plan Name"
    roomName: string; // Untuk pengelompokan
};

const customStyles: StylesConfig<RatePlanOption, false, GroupBase<RatePlanOption>> = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
};

interface RatePlanSelectorProps {
    options: GroupBase<RatePlanOption>[];
    value: RatePlanOption | null;
    onChange: (option: RatePlanOption | null) => void;
    isLoading: boolean;
}

const RatePlanSelector: React.FC<RatePlanSelectorProps> = ({ options, value, onChange, isLoading }) => {
    return (
        <div className="d-flex align-items-center" style={{ minWidth: '300px' }}>
            <span className="me-2 fw-medium text-muted small text-nowrap">Target Rate Plan:</span>
            <Select<RatePlanOption, false, GroupBase<RatePlanOption>>
                className="flex-grow-1"
                options={options}
                value={value}
                onChange={onChange}
                placeholder="Select a rate plan to target..."
                isClearable
                isLoading={isLoading}
                isDisabled={isLoading || options.length === 0}
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="absolute"
                formatGroupLabel={(group) => (
                    <div className="d-flex justify-content-between align-items-center">
                        <strong className="text-primary">{group.label}</strong>
                        <span className="badge bg-secondary-lt">{group.options.length}</span>
                    </div>
                )}
            />
        </div>
    );
};

export default RatePlanSelector;